import React from 'react';
import { DermaClinicDashboard } from './components/DermaClinicDashboard';
export function App() {
  return <DermaClinicDashboard data-id="element-0" />;
}